module.exports = __webpack_public_path__ + "static/fonts/AvenirMedium.a5f4c4f.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/avenir/AvenirMedium.woff
// module id = g+uD
// module chunks = 1